var parent = require('../../es/instance/find');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/find.js
// module id = 6462
// module chunks = 25